/* Relevo Amla PDP — vanilla port of the reference page behaviour (no jQuery/slick) */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = document.getElementById('am-main');
    if (!root) return;

    /* ---- gallery ---- */
    var track = root.querySelector('[data-am-track]');
    var thumbs = root.querySelectorAll('[data-am-thumbs] img');
    var thumbRow = root.querySelector('[data-am-thumbs]');
    var slides = track ? track.children : [];
    var current = 0;
    function go(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark();
    }
    function mark() {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-current', j === current); });
      var t = thumbs[current];
      if (t && thumbRow) thumbRow.scrollTo({ left: t.offsetLeft - thumbRow.offsetLeft - thumbRow.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = slides[0] ? slides[0].getBoundingClientRect().width + 12 : 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== current) { current = i; mark(); }
        });
      }, { passive: true });
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    var prev = root.querySelector('[data-am-prev]'), next = root.querySelector('[data-am-next]');
    prev && prev.addEventListener('click', function () { go(current - 1); });
    next && next.addEventListener('click', function () { go(current + 1); });

    /* ---- tier selection ---- */
    var items = root.querySelectorAll('.product-offer__variant-item');
    var input = document.getElementById('am-variant-id');
    var buy = document.getElementById('am-buy');
    var btnPrice = buy.querySelector('.btn-price'), btnCompare = buy.querySelector('.btn-compare');
    function select(item) {
      items.forEach(function (v) { v.classList.remove('selected'); v.setAttribute('aria-checked', 'false'); });
      item.classList.add('selected'); item.setAttribute('aria-checked', 'true');
      input.value = item.dataset.id;
      btnPrice.innerHTML = item.dataset.price;
      btnCompare.innerHTML = item.dataset.comparePrice || '';
      btnCompare.style.display = item.dataset.comparePrice ? 'inline' : 'none';
    }
    items.forEach(function (item) {
      item.addEventListener('click', function () { select(item); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(item); } });
    });

    /* ---- checkout handoff ----
       Phoenix (layout/theme.liquid) only intercepts /checkout via the Navigation API, which iPhone Safari
       and in-app browsers lack, so a plain location change there lands on Shopify checkout. Instead we
       click a hidden button[name="checkout"] - a selector Phoenix hooks in every browser - and let it
       build its own redirect. No Phoenix on the page -> native checkout. */
    var phxBtn = null;
    if (window.__PHX_CHECKOUT_URL) {
      phxBtn = document.createElement('button');
      phxBtn.type = 'button';
      phxBtn.name = 'checkout';
      phxBtn.hidden = true;
      phxBtn.tabIndex = -1;
      phxBtn.setAttribute('aria-hidden', 'true');
      phxBtn.className = 'am-phx-checkout';
      document.body.appendChild(phxBtn);
    }
    function goCheckout() {
      if (!phxBtn || !window.__PHX_CHECKOUT_URL) { window.location.href = '/checkout'; return; }
      var left = false;
      window.addEventListener('pagehide', function () { left = true; }, { once: true });
      window.addEventListener('beforeunload', function () { left = true; }, { once: true });
      phxBtn.click();
      /* safety net: if Phoenix never navigates, don't strand the shopper */
      setTimeout(function () { if (!left && document.visibilityState === 'visible') window.location.href = '/checkout'; }, 8000);
    }

    /* ---- buy: same flow as the reference (single order, straight to checkout) ---- */
    buy.addEventListener('click', function (e) {
      e.preventDefault();
      var id = input.value;
      if (!id) return;
      buy.classList.add('loading'); buy.disabled = true;
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: '{}' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); goCheckout(); })
        .catch(function (err) {
          console.error('[am] add to cart failed', err);
          /* if the item made it into the cart, still hand off to Phoenix; otherwise let them retry */
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              if (c && c.item_count > 0) { goCheckout(); return; }
              buy.classList.remove('loading'); buy.disabled = false;
            })
            .catch(function () { buy.classList.remove('loading'); buy.disabled = false; });
        });
    });
    window.addEventListener('pageshow', function () { buy.classList.remove('loading'); buy.disabled = false; });

    /* ---- delivery date ---- */
    var stock = root.querySelector('.product-offer__stock-message');
    if (stock) {
      var d = new Date(); d.setDate(d.getDate() + (parseInt(stock.dataset.days, 10) || 5));
      var n = d.getDate(), sfx = (n > 3 && n < 21) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
      stock.querySelector('span').insertAdjacentHTML('beforeend', ' <span class="date">' + d.toLocaleString('en-US', { month: 'long' }) + ' ' + n + sfx + '</span>');
    }

    /* ---- mobile sticky CTA ---- */
    var sticky = root.querySelector('[data-am-sticky]');
    var wrapper = root.querySelector('.product-offer__wrapper');
    if (sticky && wrapper) {
      var footer = document.querySelector('footer, .footer, .site-footer');
      var onScroll = function () {
        var passed = wrapper.getBoundingClientRect().bottom <= 0;
        var touching = footer && sticky.getBoundingClientRect().bottom >= footer.getBoundingClientRect().top;
        sticky.classList.toggle('visible', passed && !touching);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      sticky.querySelector('button').addEventListener('click', function (e) {
        e.preventDefault();
        var top = document.getElementById('product-form') || wrapper;
        window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      });
      onScroll();
    }
  });

  /* ---- accordions (buy box + FAQ), one open at a time ---- */
  ready(function () {
    var items = document.querySelectorAll('.amx .faq-accordion__item');
    items.forEach(function (item) {
      var trigger = item.querySelector('.faq-accordion__item-title');
      var content = item.querySelector('.faq-accordion__item-description');
      if (!trigger || !content) return;
      content.style.height = '0px'; content.style.overflow = 'hidden'; content.style.paddingBottom = '0px';
      trigger.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (o) {
          if (o === item) return;
          o.classList.remove('is-open');
          var c = o.querySelector('.faq-accordion__item-description');
          if (c) { c.style.height = '0px'; c.style.paddingBottom = '0px'; }
        });
        if (open) { content.style.height = '0px'; content.style.paddingBottom = '0px'; item.classList.remove('is-open'); return; }
        item.classList.add('is-open');
        content.style.height = 'auto';
        var full = content.scrollHeight + 'px';
        content.style.height = '0px';
        requestAnimationFrame(function () { content.style.height = full; content.style.paddingBottom = '20px'; });
      });
    });
  });

  /* ---- timeline reveal ---- */
  ready(function () {
    var els = document.querySelectorAll('.amx .progress-timeline__item');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('active'); }); return; }
    var queue = [], busy = false;
    function run() {
      if (busy || !queue.length) return;
      busy = true; queue.shift().classList.add('active');
      setTimeout(function () { busy = false; run(); }, 800);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !en.target.classList.contains('active') && queue.indexOf(en.target) < 0) { queue.push(en.target); run(); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  });

  /* ---- percentage counters ---- */
  ready(function () {
    var els = document.querySelectorAll('.amx .progress-counter__item-counter');
    function animate(el) {
      var target = parseInt(el.getAttribute('data-percentage'), 10) || 0, t0 = performance.now();
      (function step(t) {
        var p = Math.min((t - t0) / 1500, 1);
        el.textContent = Math.floor(p * target) + '%';
        if (p < 1) requestAnimationFrame(step); else el.textContent = target + '%';
      })(t0);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.textContent = e.dataset.percentage + '%'; }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !en.target.classList.contains('counted')) { en.target.classList.add('counted'); animate(en.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  });
})();
